// ----------------------------------------------------------------------------
// Nombre del Programa : Loged
// Autor               : Daniel Medina
// Compania            : Forward
// Proyecto/Procliente : P-24-1448-21                      Fecha: 18/AGO/2023
// Descripcion General : Clase que se utiliza la vista y funciones de el home de usuario una vez logeado
// Programa Dependiente: N/A
// Programa Subsecuente: N/A
// Cond. de ejecucion  : N/A
// Dias de ejecucion   : N/A                                 Horario: N/A
//                              MODIFICACIONES
// Se agrego funcionalidad para mostrar el buscador 11/JUL/2024
// Se agrego funcionalidad de notas favoritas y eventos importante 12/JUL/2024
// Se actualizaron diseños responsivos 13/JUL/2024
// ----------------------------------------------------------------------------
// Numero de Parametros:
// Parametros Entrada  :                                    Formato:
//
// Parametros Salida   : N/A                                Formato: N/A
// ----------------------------------------------------------------------------

import { Carousel, Col, Row } from "react-bootstrap";
import "./Home.scss";
import "react-status-alert/dist/status-alert.css";
import Simplert from "react-simplert";
import { LogoCarousel } from "../../components/logo-carousel/LogoCarousel";
import { OtraHerramenta } from "../../components/otra-herramienta/OtraHerramienta";
import { TarjetaComunicado } from "../../components/tarjeta-comunicado/TarjetaComunicado";
import { Paginador } from "../../components/paginador/Paginador";
import { Link, useNavigate } from "react-router-dom";
import { Button } from "react-bootstrap";
import { StatusAlertService } from "react-status-alert";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { EnlacesProps } from "../../interfaces/enlacesInterfaces";
import { getEnlacesHome } from "../../Services/EnlacesService";
import {
  getComunicadosHome,
  getComunicadoFavoritos,
  deleteFavorito,
  deleteAllFavorito,
} from "../../Services/ComunicadosService";
import {
  ComunicadosProps,
  FavoritosProps,
  RecordatoriosProps,
  FavoritosImportantesDeleteProps,
  FavoritosImportantesDeleteAllProps,
} from "../../interfaces/comunicadosInterfaces";
import { getApiUrl } from "../../Utilidades/session";
import Card from "react-bootstrap/Card";

export const Loged = () => {
  const PAGE_SIZE = 6;
  const [enlaces, setEnlaces] = useState<EnlacesProps[]>([]);
  const [comunicados, setComunicados] = useState<ComunicadosProps[]>([]);
  //Modificacion: Marca de Inicio WII C-24-1229-24
  const [favoritos, setFavoritos] = useState<FavoritosProps[]>([]);
  const [recordatorios, setRecordatorios] = useState<RecordatoriosProps[]>([]);
  const [pagActual, setPagActual] = useState<number>(0);
  const [cargado, setCargado] = useState<boolean>(false);
  const [palabraClave, setPalabraClave] = useState("");
  const usergoogleid = useSelector((state: any) => state.authUser.googleId);
  const [tipoBorrado, setTipoBorrado] = useState<number>(0);

  const [mostrarAlerta, setMostrarAlerta] = useState<boolean>(false);
  const [favoritoBorrar, setFavoritoBorrar] = useState<{
    idp: number;
    index: number;
    tipo: number;
  }>({
    idp: 0,
    index: 0,
    tipo: 0,
  });

  const navigate = useNavigate();

  useEffect(() => {
    cargarEnlaces();
    cargarComunicados();
    cargarFavoritosImportantes();
  }, []);

  const comunicadosMostrados = () =>
    comunicados.filter(
      (_, i) =>
        i >= PAGE_SIZE * pagActual && i <= PAGE_SIZE * pagActual + PAGE_SIZE - 1
    );

  const cargarEnlaces = async () => {
    const response: any = await getEnlacesHome().catch(() => {
      const noroles: EnlacesProps[] = [];
      setEnlaces(noroles);
    });
    if (response.data && response.data.data) {
      setEnlaces(response.data.data);
    }
  };

  const cargarComunicados = async () => {
    setCargado(false);
    const response: any = await getComunicadosHome().catch(() => {});
    if (response.data?.data) {
      const com = response.data.data;
      setCargado(true);
      setComunicados(com);
    }
  };

  const cargarFavoritosImportantes = async () => {
    const response: any = await getComunicadoFavoritos(usergoogleid).catch(
      () => {}
    );
    if (response.data?.data) {
      setRecordatorios(response.data.data.recordatorios);
      setFavoritos(response.data.data.favoritos);
    }
  };

  const borrarFavoritos = async (idp: number, index: number, tipo: number) => {
    setFavoritoBorrar({ idp: idp, index: index, tipo: tipo });
    setTipoBorrado(tipo);
    setMostrarAlerta(true);
  };
  const borrarTodosFavoritos = async (tipo: number) => {
    setTipoBorrado(tipo);
    setMostrarAlerta(true);
  };
  const confirmarBorrarFavorito = async () => {
    if (tipoBorrado === 1 || tipoBorrado === 2) {
      setMostrarAlerta(false);
      let favoritosImportantes = {} as FavoritosImportantesDeleteProps;
      favoritosImportantes.comunicadofavorito_id = favoritoBorrar.idp;
      const response: any = await deleteFavorito(favoritosImportantes).catch(
        ({ response }) => {
          const { data } = response;
          StatusAlertService.showError(data.meta.message);
        }
      );
      if (response.data && response.data.data) {
        if (tipoBorrado === 1) {
          const elementosnoeli = recordatorios.filter(
            (recordatorios) =>
              recordatorios.comunicadofavorito_id !== favoritoBorrar.idp
          );
          setRecordatorios(elementosnoeli);
        } else if (tipoBorrado === 2) {
          const elementosnoeli = favoritos.filter(
            (favoritos) =>
              favoritos.comunicadofavorito_id !== favoritoBorrar.idp
          );
          setFavoritos(elementosnoeli);
        }
        StatusAlertService.showSuccess("Borrado Exitosamente");
      }
    }
    if (tipoBorrado === 3 || tipoBorrado === 4) {
      setMostrarAlerta(false);
      let favoritosImportantes = {} as FavoritosImportantesDeleteAllProps;
      favoritosImportantes.idu_google = usergoogleid;
      favoritosImportantes.tipofavorito = tipoBorrado === 3 ? "REC" : "FAV";
      const response: any = await deleteAllFavorito(favoritosImportantes).catch(
        ({ response }) => {
          const { data } = response;
          StatusAlertService.showError(data.meta.message);
        }
      );
      if (response.data && response.data.data) {
        if (tipoBorrado === 3) {
          const elementosnoeli = recordatorios.filter(
            (recordatorios) => recordatorios.comunicadofavorito_id === 0
          );
          setRecordatorios(elementosnoeli);
        } else if (tipoBorrado === 4) {
          const elementosnoeli = favoritos.filter(
            (favoritos) => favoritos.comunicadofavorito_id === 0
          );
          setFavoritos(elementosnoeli);
        }
        StatusAlertService.showSuccess("Borrados Exitosamente");
      }
    }
  };

  const cambiarPagina = (pag) => {
    setPagActual(pag);
  };

  const enterTexto = (target: any) => {
    if (target.key === "Enter") {
      abrirBuscador();
    }
  };

  const abrirBuscador = async () => {
    if (palabraClave === "") {
      StatusAlertService.showError("Ingrese la palabra clave");
      return;
    }
    //var palabrabusqueda = window.btoa(palabraClave);
    navigate("/buscador/", {
      replace: false,
      state: { palabraClave: palabraClave },
    });
  };
  const abrirCalendar = (url_calendario: string) => {
    window.open(url_calendario, "_blank");
  };
  //Modificacion: Marca de Fin WII C-24-1229-24

  return (
    <>
      <Simplert
        showSimplert={mostrarAlerta}
        type="info"
        title={
          tipoBorrado === 1 || tipoBorrado === 2
            ? "¿Desea Eliminarlo?"
            : "¿Desea Eliminarlos?"
        }
        message=""
        customCloseBtnText="Cancelar"
        customConfirmBtnText="Aceptar"
        customConfirmBtnClass="btn-confirm"
        customCloseBtnClass="btn-cerrar"
        disableOverlayClick={true}
        useConfirmBtn={true}
        onConfirm={() => confirmarBorrarFavorito()}
        onClose={() => setMostrarAlerta(false)}
      />
      <Row className="botoncentrado mt-3 textobuscadormovil">
        <InputGroup className="mb-3">
          <Button
            className="btn-buscador"
            onClick={() => abrirBuscador()}
            variant="primary"
          >
            <div className="material-icons">search</div>
          </Button>
          <Form.Control
            placeholder="Busca por palabra clave"
            value={palabraClave}
            onChange={(e) => setPalabraClave(e.target.value)}
            onKeyPress={enterTexto}
            aria-describedby="basic-addon1"
          />
        </InputGroup>
      </Row>
      <Row className="mb-2">
        <Col>
          <Carousel className="p-0 carrusel">
            {comunicados.filter((e) => e.destacado).length > 0 ? (
              comunicados
                .filter((e) => e.destacado)
                .map((comunicado) => {
                  return (
                    <Carousel.Item key={comunicado.comunicado_id}>
                      <Link
                        to={"/vista-comunicado/" + comunicado.comunicado_id}
                      >
                        <img
                          className="imagen-carrusel"
                          src={comunicado.urlImagenBanner}
                        />
                        <img
                          className="imagen-carruselmovil"
                          src={comunicado.urlImagenHome}
                        />
                      </Link>
                    </Carousel.Item>
                  );
                })
            ) : cargado ? (
              <div className="colorgray2 nocomunicados">
                <h2 className="texto">No Existen Comunicados Destacados</h2>
              </div>
            ) : (
              ""
            )}
          </Carousel>
        </Col>
      </Row>
      <Row className="m-3 mx-0">
        <Col>
          <span className="heading-1 red-dark">Enlaces directos</span>
        </Col>
      </Row>
      <Row className="m-3 mx-0 margenbx05">
        <Col>
          <LogoCarousel
            enlaces={enlaces.filter((e) => e.principal)}
          ></LogoCarousel>
        </Col>
      </Row>
      <Row className="mt-3 mx-0">
        <Col md={9} className="comunicados-container">
          <Row wrap="">
            {comunicadosMostrados().map((comunicado) => {
              return (
                <Col md={6} key={comunicado.comunicado_id} className="p-2">
                  <TarjetaComunicado
                    comunicado={comunicado}
                  ></TarjetaComunicado>
                </Col>
              );
            })}
          </Row>
          <Row>
            <Col>
              <Paginador
                tamanoPagina={PAGE_SIZE}
                totalRegistros={comunicados.length}
                paginaCambiada={cambiarPagina}
              ></Paginador>
            </Col>
          </Row>
        </Col>
        <Col className="conectate-container" md={3}>
          <Row className="botoncentrado mt-3 textobuscadorpc">
            <InputGroup className="mb-3">
              <Button
                className="btn-buscador"
                onClick={() => abrirBuscador()}
                variant="primary"
              >
                <div className="material-icons">search</div>
              </Button>
              <Form.Control
                placeholder="Busca por palabra clave"
                value={palabraClave}
                onChange={(e) => setPalabraClave(e.target.value)}
                onKeyPress={enterTexto}
                aria-describedby="basic-addon1"
              />
            </InputGroup>
          </Row>
          <Row>
            <Col className="heading-1 red-dark margenconectate">Conéctate</Col>
          </Row>
          <Row className="mt-1" wrap="">
            {enlaces
              .filter((e) => !e.principal)
              .map((enlace, index) => {
                return (
                  <>
                    {index == 0 && (
                      <Col
                      md="12"
                        className="mt-3"
                        key={`e_${enlace.enlace_id}`}
                      >
                        <OtraHerramenta enlace={enlace}></OtraHerramenta>
                      </Col>
                    )}

                    {index != 0 && (
                      <Col md="12"
                        className="mt-3 minimo-otraherramienta "
                        key={`e_${enlace.enlace_id}`}
                      >
                        <OtraHerramenta enlace={enlace}></OtraHerramenta>
                      </Col>
                    )}
                  </>
                );
              })}
          </Row>

          <Row className="mt-3">
            <Col className="heading-1 red-dark">Notas favoritas</Col>
            {favoritos.length > 0 ? (
              <Col
                onClick={() => borrarTodosFavoritos(4)}
                className="heading-1 colorgray5 textend cursospointer"
              >
                Eliminar todos
              </Col>
            ) : null}
          </Row>
          <Row className="mt-0" wrap="">
            <Col>
              {favoritos.length > 0 ? (
                favoritos.map((comunicado, index) => (
                  <Card
                    key={comunicado.comunicadofavorito_id}
                    className="cartafavoritos mt-1"
                  >
                    <Card.Body className="cuerpocartafavoritos">
                      <Link
                        className="linknegro"
                        to={"/vista-comunicado/" + comunicado.comunicado_id}
                      >
                        <Card.Title className="h6 titulotextocarta cursospointer">
                          {comunicado.titulocomunicado}
                        </Card.Title>
                      </Link>
                      <div className="d-flex flex-row-reverse bd-highlight cursospointer">
                        <Button
                          onClick={() =>
                            borrarFavoritos(
                              comunicado.comunicadofavorito_id,
                              index,
                              2
                            )
                          }
                          variant="primary"
                          className="btneliminartem"
                        >
                          <div className="material-icons eliminartem">
                            delete
                          </div>
                        </Button>
                      </div>
                    </Card.Body>
                  </Card>
                ))
              ) : cargado ? (
                <Row className="titulonodatos nodatoshome colorgray2 m-0">
                  <Col className="heading-1 pt-4">
                    No existen notas favoritas
                  </Col>
                </Row>
              ) : (
                <tr></tr>
              )}
            </Col>
          </Row>

          <Row className="mt-4">
            <Col className="heading-1 red-dark">Eventos importantes</Col>
            {recordatorios.length > 0 ? (
              <Col
                onClick={() => borrarTodosFavoritos(3)}
                className="heading-1 colorgray5 textend cursospointer"
              >
                Eliminar todos
              </Col>
            ) : null}
          </Row>
          <Row className="mt-0" wrap="">
            <Col>
              {recordatorios.length > 0 ? (
                recordatorios.map((comunicado, index) => (
                  <Card
                    key={comunicado.comunicadofavorito_id}
                    className="cartafavoritos mt-1"
                  >
                    <Card.Body className="cuerpocartafavoritos">
                      <Link
                        className="linknegro"
                        to={"/vista-comunicado/" + comunicado.comunicado_id}
                      >
                        <Card.Title className="h6 titulotextocarta cursospointer">
                          {comunicado.titulocomunicado}
                        </Card.Title>
                      </Link>
                      <div className="d-flex flex-row-reverse bd-highlight cursospointer">
                        <Button
                          onClick={() =>
                            borrarFavoritos(
                              comunicado.comunicadofavorito_id,
                              index,
                              1
                            )
                          }
                          variant="primary"
                          className="btneliminartem"
                        >
                          <div className="material-icons eliminartem">
                            delete
                          </div>
                        </Button>
                      </div>
                      <Card.Text
                        onClick={() => abrirCalendar(comunicado.urlCalendario)}
                        className="textocarta cursospointer"
                      >
                        Configurar recordatorio en calendario
                      </Card.Text>
                    </Card.Body>
                  </Card>
                ))
              ) : cargado ? (
                <Row className="titulonodatos nodatoshome colorgray2 m-0">
                  <Col className="heading-1 pt-4">
                    No existen eventos importantes
                  </Col>
                </Row>
              ) : (
                <tr></tr>
              )}
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
};
